<template>
  <div>
    <section
      class="box-detail form-detail"
      v-if="
        dataContract.groupService !== 'SELL' &&
        dataContract.lstAppendixEditInfo &&
        dataContract.lstAppendixEditInfo.length > 0
      "
    >
      <h1>Phụ lục đổi thông tin</h1>
      <div class="table-responsive">
        <table class="table table-hover table-bordered">
          <thead class="thead-light">
            <tr>
              <th scope="col" class="text-left">Số phụ lục</th>
              <th scope="col" class="text-left">Thời gian</th>
              <th scope="col" class="text-left">Nội dung đổi</th>
              <th scope="col" class="text-right">Trạng thái</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in dataContract.lstAppendixEditInfo" :key="index">
            <tr class="table-row">
              <td align="left">{{ item.code }}</td>
              <td align="left">
                <p v-if="item.dateCreatedAppendixDTO || item.dateCreate">
                  <b>Ngày tạo :</b>
                  {{
                    item.dateCreatedAppendixDTO
                      ? item.dateCreatedAppendixDTO
                      : item.dateCreate | formatDate('HH:mm DD/MM/YYYY')
                  }}
                </p>
                <p
                  v-if="
                    item.state &&
                    (item.state === 'SIGNED_WAITING_APPROVED' ||
                      item.state === 'APPROVED' ||
                      item.state === 'REJECTED_SA') &&
                    (item.dateSignAppendixDTO || item.dateSign)
                  "
                >
                  <b>Ngày ký :</b>
                  {{
                    item.dateSignAppendixDTO ? item.dateSignAppendixDTO : item.dateSign | formatDate
                  }}
                </p>
                <p v-if="item.state && item.state === 'CANCELED' && item.dateCancelDTO">
                  <b>Ngày huỷ :</b> {{ item.dateCancelDTO | formatDate }}
                </p>
              </td>
              <td align="left">
                {{ item.appendixChange.typeAppendixChange | mapTextTypeChange }}
              </td>
              <td align="right">
                <p class="f12 badge" v-bind:class="[item.state ? item.state : '']">
                  {{ item.state | mapTextStatus(listStatusContract) }}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'

  export default {
    props: ['dataContract'],
    data() {
      return {
        listStatusContract: Config.listStatusContract,
      }
    },
    methods: {},
  }
</script>

<style scoped></style>
